import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=a2498166&scoped=true&"
import script from "./AddressBook.vue?vue&type=script&lang=js&"
export * from "./AddressBook.vue?vue&type=script&lang=js&"
import style0 from "./AddressBook.vue?vue&type=style&index=0&id=a2498166&lang=scss&scoped=true&"
import style1 from "./AddressBook.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2498166",
  null
  
)

export default component.exports